'use strict';

const Translator = require('./../../core/translator');

module.exports = {
  'items': [
    {
      'title': Translator.translate('video_help1'),
      'url': 'https://www.youtube.com/embed/cBWbDNyJ6ds?rel=0&autoplay=1',
    },
    {
      'title': Translator.translate('video_help2'),
      'url': 'https://www.youtube.com/embed/VVWMIOc2YJs?rel=0&autoplay=1',
    },
    {
      'title': Translator.translate('video_help3'),
      'url': 'https://www.youtube.com/embed/P7LdfDn0Yso?rel=0&autoplay=1',
    },
    {
      'title': Translator.translate('video_help6'),
      'url': 'https://www.youtube.com/embed/sSt2-RAyGnk?rel=0&autoplay=1',
    },
    {
      'title': Translator.translate('video_help4'),
      'url': 'https://www.youtube.com/embed/6J0ioEnQtgw?rel=0&autoplay=1',
    },
    {
      'title': Translator.translate('video_help10'),
      'url': 'https://www.youtube.com/embed/YmtWVNqzWiY?rel=0&autoplay=1',
    },
    {
      'title': Translator.translate('video_help9'),
      'url': 'https://www.youtube.com/embed/KlH0sJPCILI?rel=0&autoplay=1',
    },
    {
      'title': Translator.translate('video_help11'),
      'url': 'https://www.youtube.com/embed/BRZSzK2gDTU?rel=0&autoplay=1',
    },
    {
      'title': Translator.translate('video_help8'),
      'url': 'https://www.youtube.com/embed/7A2KbzPHcIE?rel=0&autoplay=1',
    },
    {
      'title': Translator.translate('video_help7'),
      'url': 'https://www.youtube.com/embed/3SL6bYQ-sng?rel=0&autoplay=1',
    },
    {
      'title': Translator.translate('video_help5'),
      'url': 'https://www.youtube.com/embed/wEZxvW0JzC0?rel=0&autoplay=1',
    },
  ],
  'links': {
    'global': {
      'fr': 'https://www.support.backbee.com/fr/',
      'en': 'https://www.support.backbee.com/en/',
    },
    'error_management_404': {
      'fr': 'https://www.support.backbee.com/fr/personnaliser-la-page-d-erreur-404',
      'en': 'https://www.support.backbee.com/en/customize-the-404-error-page',
    },
    'error_management_500': {
      'fr': 'https://www.support.backbee.com/fr/personnaliser-la-page-d-erreur-500',
      'en': 'https://www.support.backbee.com/en/customize-the-500-error-page',
    },
    'website_on_google': {
      'fr': 'https://www.support.backbee.com/fr/activerdesactiver-l-indexation-de-votre-site-sur-google',
      'en': 'https://www.support.backbee.com/en/enabling-and-disabling-referencing-of-your-site-on-google',
    },
    'analytics': {
      'fr': 'https://www.support.backbee.com/fr/google-analytics',
      'en': 'https://www.support.backbee.com/en/google-analytics',
    },
    'favicon': {
      'fr': 'https://www.support.backbee.com/fr/ajouter-un-favicon-au-site-internet',
      'en': 'https://www.support.backbee.com/en/add-a-favicon-to-the-website',
    },
    'tag_management': {
      'fr': 'https://www.support.backbee.com/fr/gestion-des-categories',
      'en': 'https://www.support.backbee.com/en/tag-management',
    },
    'change_password': {
      'fr': 'https://www.support.backbee.com/fr/changer-votre-mot-de-passe',
      'en': 'https://www.support.backbee.com/en/change-your-password',
    },
    'user_management': {
      'fr': 'https://www.support.backbee.com/fr/modifier-les-informations-sur-les-utilisateurs-actuels-du-back-office',
      'en': 'https://www.support.backbee.com/en/change-information-about-current-back-office-users',
    },
    'user_management_add': {
      'fr': 'https://www.support.backbee.com/fr/ajouter-de-nouveaux-utilisateurs-du-back-office',
      'en': 'https://www.support.backbee.com/en/add-new-users-to-the-back-office',
    },
    'user_management_edit': {
      'fr': 'https://www.support.backbee.com/fr/modifier-les-informations-sur-les-utilisateurs-actuels-du-back-office',
      'en': 'https://www.support.backbee.com/en/change-information-about-current-back-office-users',
    },
    'user_management_delete': {
      'fr': 'https://www.support.backbee.com/fr/supprimer-des-utilisateurs-du-back-office',
      'en': 'https://www.support.backbee.com/en/remove-users-from-the-back-office',
    },
    'translate_bo': {
      'fr': 'https://www.support.backbee.com/fr/choisir-la-langue-du-back-office',
      'en': 'https://www.support.backbee.com/en/choose-the-language-of-the-back-office',
    },
    'page_parameters': {
      'fr': 'https://www.support.backbee.com/fr/creer-et-gerer-vos-pages',
      'en': 'https://www.support.backbee.com/en/manage-page-parameters',
    },
    'search_page': {
      'fr': 'https://www.support.backbee.com/fr/rechercher-une-page',
      'en': 'https://www.support.backbee.com/en/search-a-page',
    },
    'add_page': {
      'fr': 'https://www.support.backbee.com/fr/creer-une-nouvelle-page',
      'en': 'https://www.support.backbee.com/en/create-a-new-page',
    },
    'content_Text/Button': {
      'fr': 'https://www.support.backbee.com/fr/bouton',
      'en': 'https://www.support.backbee.com/en/button',
    },
    'content_Media/Video': {
      'fr': 'https://www.support.backbee.com/fr/video',
      'en': 'https://www.support.backbee.com/en/video',
    },
    'content_Basic/Slider': {
      'fr': 'https://www.support.backbee.com/fr/slider',
      'en': 'https://www.support.backbee.com/en/slider',
    },
    'content_Basic/Searchbar': {
      'fr': 'https://www.support.backbee.com/fr/moteur-de-recherche',
      'en': 'https://www.support.backbee.com/en/search-engine',
    },
    'content_Content/HighlightContent': {
      'fr': 'https://www.support.backbee.com/fr/focus',
      'en': 'https://www.support.backbee.com/en/focus',
    },
    'content_ContentAutoblock': {
      'fr': 'https://www.support.backbee.com/fr/liste',
      'en': 'https://www.support.backbee.com/en/list',
    },
    'content_Comment/Disqus': {
      'fr': 'https://www.support.backbee.com/fr/disqus',
      'en': 'https://www.support.backbee.com/en/disqus',
    },
    'content_Social/Icons': {
      'fr': 'https://www.support.backbee.com/fr/liens-reseaux-sociaux',
      'en': 'https://www.support.backbee.com/en/links-social-networks',
    },
    'content_Social/Share': {
      'fr': 'https://www.support.backbee.com/fr/partage-reseaux-sociaux',
      'en': 'https://www.support.backbee.com/en/share-social-networks',
    },
    'content_Social/Tweet': {
      'fr': 'https://www.support.backbee.com/fr/tweet',
      'en': 'https://www.support.backbee.com/fr/tweet',
    },
    'content_Basic/Contact': {
      'fr': 'https://www.support.backbee.com/fr/formulaire-de-contact',
      'en': 'https://www.support.backbee.com/en/contact-form',
    },
    'content_Media/Adsense': {
      'fr': 'https://www.support.backbee.com/fr/adsense',
      'en': 'https://www.support.backbee.com/en/adsense',
    },
    'content_Media/Bandsintown': {
      'fr': 'https://www.support.backbee.com/fr/bandsintown',
      'en': 'https://www.support.backbee.com/en/bandsintown',
    },
    'content_Basic/Image': {
      'fr': 'https://www.support.backbee.com/fr/referencer-vos-images',
      'en': 'https://www.support.backbee.com/en/referencing-your-images',
    },
    'content_Media/Map': {
      'fr': 'https://www.support.backbee.com/fr/carte',
      'en': 'https://www.support.backbee.com/en/map',
    },
    'content_Media/Soundcloud': {
      'fr': 'https://www.support.backbee.com/fr/soundcloud',
      'en': 'https://www.support.backbee.com/en/soundcloud',
    },
    'content_Basic/Liner': {
      'fr': 'https://www.support.backbee.com/fr/filet',
      'en': 'https://www.support.backbee.com/en/liner',
    },
    'content_Basic/Spacer': {
      'fr': 'https://www.support.backbee.com/fr/espace',
      'en': 'https://www.support.backbee.com/en/spacer',
    },
    'content_Basic/Menu': {
      'fr': 'https://www.support.backbee.com/fr/ajouter-une-page-au-menu',
      'en': 'https://www.support.backbee.com/en/adding-a-page-to-the-menu',
    },
    'content_Text/Paragraph': {
      'fr': 'https://www.support.backbee.com/fr/saisir-du-texte',
      'en': 'https://www.support.backbee.com/en/adjust-your-text-blocks',
    },
    'content_Article/ArticleTitle': {
      'fr': 'https://www.support.backbee.com/fr/gerer-le-bloc-titre-de-la-page',
      'en': 'https://www.support.backbee.com/en/manage-your-block-page-title',
    },
    'content_Basic/Title': {
      'fr': 'https://www.support.backbee.com/fr/gerer-le-bloc-titre-de-la-page',
      'en': 'https://www.support.backbee.com/en/manage-your-block-page-title',
    },
    'row_settings_style': {
      'fr': 'https://www.support.backbee.com/fr/mettre-une-image-de-fond',
      'en': 'https://www.support.backbee.com/en/add-a-background-image',
    },
    'row_settings_margin': {
      'fr': 'https://www.support.backbee.com/fr/gerer-les-marges',
      'en': 'https://www.support.backbee.com/en/manage-margins-and-spaces',
    },
    'row_settings_mobile': {
      'fr': 'https://www.support.backbee.com/fr/gerer-l-affichage-sur-un-mobile',
      'en': 'https://www.support.backbee.com/en/manage-display-on-a-mobile-device',
    },
    'authentication': {
      'fr': 'https://www.support.backbee.com/fr/se-connecter',
      'en': 'https://www.support.backbee.com/en/log-in',
    },
    'add_content': {
      'fr': 'https://www.support.backbee.com/fr/ajouter-et-gerer-vos-types-de-contenu',
      'en': 'https://www.support.backbee.com/en/add-and-manage-content-types',
    },
    'focus_image': {
      'fr': 'https://www.support.backbee.com/fr/recadrer-une-image',
      'en': 'https://www.support.backbee.com/en/resize-an-image',
    },
    'lang_management': {
      'fr': 'https://www.support.backbee.com/fr/multilangue',
      'en': 'https://www.support.backbee.com/en/activate-multilanguage',
    },
  },
};
